<template>
  <div class="screening-results-pills">
    <div class="header grey--text text--darken-2">Results</div>
    <count-pills :counts="counts" />
  </div>
</template>

<script>
import CountPills from '@/components/Common/CountPills';
import { ScreeningOutcomeSummary } from '@/models';

export default {
  name: 'ScreeningResultsPills',
  components: { CountPills },
  props: {
    outcomeSummary: {
      type: ScreeningOutcomeSummary,
      required: true,
    },
    fullTextResults: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    counts() {
      if (this.fullTextResults) {
        return [
          {
            color: 'success',
            icon: 'check',
            count: this.outcomeSummary.relevantCount ?? 0,
            tooltip: 'Included',
          },
          {
            color: 'error',
            icon: 'remove',
            count: this.outcomeSummary.notRelevantCount ?? 0,
            tooltip: 'Excluded',
          },
        ];
      }
      return [
        {
          color: 'success',
          icon: 'check',
          count: this.outcomeSummary.relevantCount ?? 0,
          tooltip: 'Relevant',
        },
        {
          color: 'warning',
          icon: 'help',
          count: this.outcomeSummary.notSureCount ?? 0,
          tooltip: 'Not Sure',
        },
        {
          color: 'error',
          icon: 'remove',
          count: this.outcomeSummary.notRelevantCount ?? 0,
          tooltip: 'Not Relevant',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.screening-results-pills {
  display: grid;
  gap: 12px;

  .header {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
